import { render, staticRenderFns } from "./QueryRoleUseCountView.vue?vue&type=template&id=383f36d6"
import script from "./QueryRoleUseCountView.vue?vue&type=script&lang=js"
export * from "./QueryRoleUseCountView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports